export { default } from './GallerySlider'
